
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalService } from '../services/global.service';
import { HttpService } from '../services/http.service';
import { configs } from '../configs/app.config';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { FormGroup, FormBuilder } from '@angular/forms';
import html2canvas from "html2canvas";
import jsPDF from 'jspdf';
import 'jspdf-autotable';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
  public profilePopup: Boolean = false;
  public sharePopup: Boolean = false;
  public shareButtonPopup: Boolean = false;
  public downloadPopup: Boolean = false;
  public cardType: Object = configs['cardType'];
  public searchArray: Array<any> = [
    { name: "monitoring", type: "route", link: 'monitoring' },
    { name: "benchmarking", type: "route", link: 'benchmarking' },
    { name: "performance", type: "route", link: 'performance', },
    { name: "diagnostic", type: "route", link: 'diagnostic', },
    { name: "wiki", type: "route", link: 'wiki', },
    { name: "settings", type: "route", link: 'settings', },
  ];
  public headerSearch: FormGroup;
  public successMessage: string = '';
  public errorMessage: string = "";
  public warningMessage = '';
  public subPopUp: string = "";

  constructor(private router: Router, private ngxService: NgxUiLoaderService, private formBuilder: FormBuilder, public globalService: GlobalService, private httpService: HttpService) {
    this.headerSearch = this.formBuilder.group({
      search_select_name: [''],
      search: [''],
    });
    var self = this;
    this.detectOutsideClicks(self);
  }
  ngAfterViewInit(){
    if(this.globalService.isBrowser)
    this.globalService.userDetails = JSON.parse(localStorage.getItem('userDetails'));
  }
  //find parent by class name
  findParentByClass(node, cls) {
    while (node && !this.hasClass(node, cls)) {
      node = node.parentNode;
    }
    return node;
  }

  onSignOut() {
    window.localStorage.clear();
    this.router.navigate(['/user']);
  }
  downloadCSV(event) {
    this.sharePopup = false;
    this.subPopUp = "";
    event.stopPropagation();
    
    this.httpService.createGetRequest(configs['api']['downloadCSV'] + this.globalService.order_id)
      .subscribe((res) => {
        if (res && res['link']) {
          this.exportToExcel(res['link']);
        }
      }, (error) => {
        // this.ngxService.stop();
        this.errorMessage = error && error['error'] && error.error['statusMessage'] &&
          (error.error['statusCode'] && error.error['statusCode'] !== 406) ? error.error['statusMessage'] : '';
        this.warningMessage = (error.error['statusCode'] && error.error['statusCode'] === 406) ? error.error['statusMessage'] : '';
        setTimeout(() => {
          this.errorMessage = "";
          this.warningMessage = "";
        }, 5000);
      });
  }
  //check it has class
  hasClass(elem, cls) {
    var str = " " + elem.className + " ";
    var testCls = " " + cls + " ";
    return (str.indexOf(testCls) !== -1);
  }

  // close select options in outside click on window
  private detectOutsideClicks(self: this) {
    var self = this;
    if (this.globalService.isBrowser) {
      document.body.addEventListener('click', function (event: any) {
        if (!event.path.some(el => el['id'] == "about-profile")) {
          if (!self.findParentByClass(event.target, "profile-drop")) {
            if (self.profilePopup === true)
              self.profilePopup = false;
          }
        }
        if (!event.path.some(el => el['id'] == "share")) {
          if (!self.findParentByClass(event.target, "export-list")) {
            if (self.sharePopup === true) {
              self.subPopUp = '';
              self.sharePopup = false;

            }
          }
        }
      });
    }
  }
  changeSelection(selectedValue: Object) {
    if (selectedValue['type'] == "route") {
      this.router.navigate(['/' + selectedValue['link']]);
    }
  }

  forPopupOpen(key) {
    this.profilePopup = false;
    this.globalService.showPopUp = key;
    document.body ? document.body.classList.add('no-scroll') : '';
  }

  downloadAsPDF(event) {
    this.sharePopup = false;
    this.subPopUp = "";
    event.stopPropagation();
    // if (this.globalService.isBrowser)
    //   window.print();
  
    setTimeout(() => {
      const data = document.getElementById('wrapper');
      if (data) {
        data.classList.add("pdf-padding");
        html2canvas(data).then(canvas => {

          var imgData = canvas.toDataURL('image/png');
          var imgWidth = 210;
          var pageHeight = 295;
          var imgHeight = canvas.height * imgWidth / canvas.width;
          var heightLeft = imgHeight;
          var pdf = new jsPDF('p', 'mm', 'a4');
          var position = 0; // give some top padding to first page
          pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
          heightLeft -= pageHeight;

          while (heightLeft >= 0) {
            position = heightLeft - imgHeight; // top padding for other pages
            pdf.addPage();
            pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
            heightLeft -= pageHeight;
          }
          pdf.save('Mozark.pdf');
          data.classList.remove("pdf-padding");

        });
      }
    }, 0);

  }

  openSubPopUp(type: string) {
    if (this.subPopUp == type)
      this.subPopUp = '';
    else
      this.subPopUp = type;
  }


  // export to excel
  public exportToExcel(url): void {
    var link: any = document.createElement("a");
    link.href = url;

    //set the visibility hidden so it will not effect on your web-layout
    link.style = "visibility:hidden";
    link.download = "export.xls"; //fileName + ".csv";

    //this part will append the anchor tag and remove it after automatic click
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
  ngDoCheck(){
    
  }
}
